<template>
  <!-- Tablero de control -->
  <v-form ref="form" autocomplete="off">
    <v-row>
      <!--DepartamentoID-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.DepartamentoID"
          :items="ArrayDpto_ID"
          :item-title="
            (ArrayDpto_ID) =>
              ArrayDpto_ID.DepartamentoId + '-' + ArrayDpto_ID.Nombre
          "
          item-value="DepartamentoId"
          color="primary"
          label="DepartamentoID :"
          dense
          :rules="[(v) => !!v || 'Campo obligatorio']"
          :update:modelValue="ChangeDepto_ID()"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Ciudad-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.CiudadID"
          :items="ArrayCiudadID"
          :item-title="
            (ArrayCiudadID) =>
              ArrayCiudadID.CiudadId + '-' + ArrayCiudadID.Nombre
          "
          item-value="CiudadId"
          color="primary"
          label="Ciudad:"
          :update:modelValue="ChangeCity_ID()"
          dense
          clearable
          :rules="[(v) => !!v || 'Campo obligatorio']"
        >
        </v-autocomplete>
      </v-col>
      <!--Localidad -->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.LocalidadCiudad"
          :items="ArrayLocalidad"
          :item-title="
            (ArrayLocalidad) =>
              ArrayLocalidad.LocalidadId + '-' + ArrayLocalidad.Nombre
          "
          item-value="LocalidadId"
          color="primary"
          label="Localidad:"
          dense
          :update:modelValue="ChangeLocalidad_ID()"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Upz-->
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          v-model="editedItem.UPZLocalidad"
          :items="ArrayUpz"
          :item-title="(ArrayUpz) => ArrayUpz.UpzId + '-' + ArrayUpz.Nombre"
          item-value="UpzId"
          color="primary"
          label="Upz:"
          dense
          clearable
        >
        </v-autocomplete>
      </v-col>
      <!--Código Postal-->
      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="editedItem.CodigoPostal"
          label="Código Postal:"
          hint="Digite Información"
          dense
          clearable
        >
        </v-text-field>
      </v-col>
      <!--Conjunto-->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.NombreConjunto"
          label="Nombre Conjunto:"
          hint="Digite Información"
          dense
          clearable
        >
        </v-text-field>
      </v-col>
      <!--Nombre Proyecto-->
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="editedItem.NombreProyecto"
          label="Nombre Proyecto:"
          hint="Digite Información"
          dense
          clearable
        >
        </v-text-field>
      </v-col>
      <!--Direcciones-->
      <v-col cols="12" sm="6" md="6">
        <card-direcciones
          v-bind:Direccion="editedItem.DireccionDetalle"
          v-on:update:Direccion="editedItem.DireccionDetalle = $event"
          v-bind:infoData="editedItem"
          v-on:update:infoData="editedItem = $event"
        ></card-direcciones>
      </v-col>
      <!--Complemento-->
      <v-col cols="12" sm="6" md="6">
        <card-complemento
          v-bind:Complemento="editedItem.ComplementoDireccion"
          v-on:update:Complemento="editedItem.ComplementoDireccion = $event"
          v-bind:infoData="editedItem"
          v-on:update:infoData="editedItem = $event"
        ></card-complemento>
      </v-col>
      <!--Dirección-->
      <v-col cols="12" sm="6" md="6">
        <span> Dirección: {{ editedItem.DireccionDetalle }} </span>
      </v-col>
      <!--Complemento-->
      <v-col cols="12" sm="6" md="6">
        <span> Complemento: {{ editedItem.ComplementoDireccion }} </span>
      </v-col>
    </v-row>
    <!--////////////////////////////////////////////// Auditoria ////////////////////////////////////////////////////////////-->
    <br />
    <v-row>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Usuario Creación: {{ editedItem.UsuarioCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span
          >Usuario Actualización: {{ editedItem.UsuarioActualizacion }}</span
        >
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Creación: {{ editedItem.FechaCreacion }}</span>
      </v-col>
      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="6">
        <span>Fecha Actualización: {{ editedItem.FechaActualizacion }}</span>
      </v-col>
    </v-row>
    <div align="right">
      <br />
      <v-btn
        size="x-large"
        v-if="!buttonSave"
        color="green"
        text
        @click="ValidateCampos"
      >
        Guardar
      </v-btn>
    </div>
  </v-form>
  <!-- Linea de progreso -->
  <div class="d-flex align-center flex-column">
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Direcciones from "@/views/TCI/Personas/Direcciones/ComponentesDirecciones/DireccionesModal.vue";
import Complementos from "@/views/TCI/Personas/Direcciones/ComponentesDirecciones/ComplementoModal.vue";
export default {
  name: "seguros_registro",
  props: {
    editedIndex: {
      type: Number,
      default: 0,
      Description: "Cambia de actualización a creación o visceversa",
    },
    infoedit: {
      type: Object,
      default: [],
      Description: "Información de datos",
    },
    tipodocumento: {
      type: Number,
      default: 0,
      Description: "Información de tipo de documento",
    },
    documento: {
      type: String,
      default: "",
      Description: "Información de documento",
    },
    page: {
      type: Boolean,
      default: false,
      Description: "Saber desde donde se llama la página",
    },
    Exito: {
      type: String,
      default: "",
      Description: "Información de respuesta post o put",
    },
  },
  components: {
    "card-direcciones": Direcciones,
    "card-complemento": Complementos,
  },
  data() {
    return {
      progreso: false,
      componenteview: 0,
      buttonSave: false,
      editedItem: {
        DireccionID: 0,
        TypeDocumentID: null,
        DocumentID: "",
        DireccionDetalle: null,
        ComplementoDireccion: null,
        PaisID: "169",
        DepartamentoID: null,
        CiudadID: null,
        LocalidadCiudad: null,
        UPZLocalidad: null,
        CodigoPostal: null,
        NombreConjunto: null,
        NombreProyecto: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        TipoViaPrincipal: null,
        NumeroViaPrincipal: null,
        ModificadorViaPrincipal: null,
        PrefijoViaPrincipal: null,
        NumeroVia: null,
        ModificadorVia: null,
        NumeroPLaca: null,
        PrefijoViaGeneradora: null,
      },
      defaultItem: {
        DireccionID: 0,
        TypeDocumentID: null,
        DocumentID: "",
        DireccionDetalle: null,
        ComplementoDireccion: null,
        PaisID: "169",
        DepartamentoID: null,
        CiudadID: null,
        LocalidadCiudad: null,
        UPZLocalidad: null,
        CodigoPostal: null,
        NombreConjunto: null,
        NombreProyecto: null,
        UsuarioCreacion: null,
        FechaCreacion: null,
        UsuarioActualizacion: null,
        FechaActualizacion: null,
        TipoViaPrincipal: null,
        NumeroViaPrincipal: null,
        ModificadorViaPrincipal: null,
        PrefijoViaPrincipal: null,
        NumeroVia: null,
        ModificadorVia: null,
        NumeroPLaca: null,
        PrefijoViaGeneradora: null,
      },
      ArrayDpto_ID: [],
      ArrayCiudadID: [],
      ArrayLocalidad: [],
      ArrayUpz: [],
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Validación de campos
    async ValidateCampos() {
      var validate = false;

      if (
        this.editedItem.TypeDocumentID == "" ||
        this.editedItem.TypeDocumentID == null ||
        this.editedItem.DocumentID == "" ||
        this.editedItem.DocumentID == null ||
        this.editedItem.DireccionDetalle == "" ||
        this.editedItem.DireccionDetalle == null ||
        this.editedItem.PaisID == "" ||
        this.editedItem.PaisID == null ||
        this.editedItem.DepartamentoID == "" ||
        this.editedItem.DepartamentoID == null ||
        this.editedItem.CiudadID == "" ||
        this.editedItem.CiudadID == null
      ) {
        validate = true;
      }
      // Consultas a Ejecutar
      if (!validate) {
        var userperfil = this.$store.getters.userperfil;
        this.editedItem.UsuarioActualizacion = userperfil.userInfo.Usuario_ID;
        this.editedItem.UsuarioCreacion = userperfil.userInfo.Usuario_ID;
        if (this.editedIndex != -1) {
          this.putRegistro();
        } else {
          this.postRegistro();
        }
      } else {
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " Hay campos que se encuentran incompletos.",
        });
        this.$refs.form.validate();
      }
    },
    // Crear Registro
    async postRegistro() {
      this.progreso = true;
      this.axios
        .post("/Personas/Direcciones/CR0/", this.editedItem)
        .then((result) => {
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", result.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Actualizacion de registro
    async putRegistro() {
      this.progreso = true;
      this.axios
        .put("/Personas/Direcciones/UP0/", this.editedItem)
        .then((response) => {
          debugger;
          this.reset();
          var data = false;
          this.$emit("update:page", data);
          this.$emit("update:Exito", response.data);
          this.$swal({
            icon: "success",
            title: "¡Éxito!",
            html: " El registro fue guardado correctamente.",
          });
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: mensajeerror,
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " El sistena ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    // Función de gestion cambio
    ChangePais_ID() {
      this.ArrayDpto_ID = [];
      this.editedItem.DepartamentoID = null;
      this.getDpto_ID();
    },
    // Get para obtener array de los DepartamentoID existentes
    getDpto_ID() {
      if (this.editedItem.PaisID == "169") {
        this.ArrayDpto_ID = [];
        var ArrayDpto_ID2 = this.$store.getters.MDpto;
        this.ArrayDpto_ID = ArrayDpto_ID2.filter(
          (item) => item.departamentoId != 0
        );
      }
    },
    // Función de gestion cambio
    ChangeDepto_ID() {
      if (
        this.editedItem.DepartamentoID == "" ||
        this.editedItem.DepartamentoID == null
      ) {
        this.ArrayCiudadID = [];
        this.editedItem.CiudadID = null;
      } else {
        this.getCiudadID();
      }
    },
    // Get para obtener array de las ciudades existentes
    getCiudadID() {
      if (
        this.editedItem.DepartamentoID != "" &&
        this.editedItem.DepartamentoID != null
      ) {
        this.ArrayCiudadID = [];
        var Dpto = this.editedItem.DepartamentoID;
        var ArrayCiudadID2 = this.$store.getters.MCity;
        this.ArrayCiudadID = ArrayCiudadID2.filter(
          (item) => item.CiudadId != 0 && item.DepartamentoId == Dpto
        );
      }
    },
    // Método de ciudad
    ChangeCity_ID() {
      if (this.editedItem.CiudadID == "" || this.editedItem.CiudadID == null) {
        this.ArrayLocalidad = [];
        this.editedItem.LocalidadCiudad = null;
      } else {
        this.getLocalidad_ID();
      }
    },
    // Get para obtener array de las localidades existentes
    getLocalidad_ID() {
      if (this.editedItem.CiudadID != "" && this.editedItem.CiudadID != null) {
        this.ArrayLocalidad = [];
        var Dpto = this.editedItem.DepartamentoID;
        var City = this.editedItem.CiudadID;

        var ArrayLocalidad2 = this.$store.getters.MLocalidad;
        this.ArrayLocalidad = ArrayLocalidad2.filter(
          (item) =>
            item.LocalidadId != 0 &&
            item.DepartamentoId == Dpto &&
            item.CiudadId == City
        );
      }
    },
    // Método de Localidad
    ChangeLocalidad_ID() {
      if (
        this.editedItem.LocalidadCiudad == "" ||
        this.editedItem.LocalidadCiudad == null
      ) {
        this.ArrayUpz = [];
        this.editedItem.UPZLocalidad = null;
      } else {
        this.getUpz_ID();
      }
    },
    // Get para obtener array de las UPZ
    getUpz_ID() {
      if (
        this.editedItem.LocalidadCiudad != "" &&
        this.editedItem.LocalidadCiudad != null
      ) {
        this.ArrayUpz = [];

        var Dpto = this.editedItem.DepartamentoID;
        var City = this.editedItem.CiudadID;
        var Localidad = this.editedItem.LocalidadCiudad;

        //UPZ
        var ArrayUpz2 = this.$store.getters.MUpz;
        this.ArrayUpz = ArrayUpz2.filter(
          (item) =>
            item.UpzId != 0 &&
            item.LocalidadId == Localidad &&
            item.DepartamentoId == Dpto &&
            item.CiudadId == City
        );
      }
    },
    ///////////////////////////////////////////////// Métodos de acciones ///////////////////////////////////////////
    reset() {
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    // Cargue Combos
    CargueCombos() {
      this.ChangePais_ID();
    },
    // Actualizar carga
    ActualizarCargue() {
      if (this.editedIndex != -1) {
        // Actualizar
        this.editedItem = this.infoedit;
      } else {
        this.editedItem.TypeDocumentID =
          this.tipodocumento != 0 ? this.tipodocumento : null;
        this.editedItem.DocumentID =
          this.documento != null ? this.documento : null;
      }
    },
  },
  created() {
    this.CargueCombos();
    this.ActualizarCargue();
  },
};
</script>
